import { render, staticRenderFns } from "./oneTest.vue?vue&type=template&id=29c4f70e&scoped=true"
import script from "./oneTest.vue?vue&type=script&lang=js"
export * from "./oneTest.vue?vue&type=script&lang=js"
import style0 from "./oneTest.vue?vue&type=style&index=0&id=29c4f70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c4f70e",
  null
  
)

export default component.exports